import http from "./http.service"


//  About Us page data
export const getAboutUsPageData = async () => {
  try {
    const response = await http.get("/pages?slug=about-us");
    return response?.data?.data?.content;
  } catch (error: any) {
    console.error("About Us Page Data Error:", error?.response || error?.message);
    return null;
  }
};

//  FAQ page data
export const getFaqPageData = async () => {
  try {
    const response = await http.get("/pages?slug=faq");
    return response?.data?.data?.faq;
  } catch (error: any) {
    console.error("FAQ Page Data Error:", error?.response || error?.message);
    return null;
  }
};

// Send Contact Us Form Data
export const sendContactForm = async (formData: {
  name: string;
  email: string;
  phone: string;
  about: string;
}) => {
  try {
    const response = await http.post("/contact/email/send", formData);
    return response.data;
  } catch (error: any) {
    console.error("Contact Form Submission Error:", error?.response || error?.message);
    throw error;
  }
};

//  Blog list page data
export const getBlogList = async (values: any) => {
  try {
    const { page = 1, limit = 6 } = values;

    const response = await http.get(`/blog/posts/list?page=${page}&limit=${limit}`);
    return response?.data;
  } catch (error: any) {
    console.error("About Us Page Data Error:", error?.response || error?.message);
    return null;
  }
};

//  Blog by ID page data
export const getBlogById = async (uuid: string) => {
  try {
    const response = await http.get(`/blog/posts/list/${uuid}`);
    return response?.data?.data;
  } catch (error: any) {
    console.error("About Us Page Data Error:", error?.response || error?.message);
    return null;
  }
};

// Terms and Conditions page data
export const getTermsAndConditions = async () => {
  try {
    const response = await http.get("/pages?slug=terms-and-conditions");
    return response?.data?.data?.content;

  } catch (error: any) {
    console.error("Fetch Policies Error:", error?.response || error?.message);
    return null;
  }
};

// Policies page data
export const getPolicies = async () => {
  try {
    const response = await http.get("/pages?slug=privacy-policy");
    return response?.data?.data?.content;

  } catch (error: any) {
    console.error("Fetch Policies Error:", error?.response || error?.message);
    return null;
  }
};

// get pricing page data
export const getPricingPageData = async () => {
  try {
    const response = await http.get("/pages?slug=pricing");
    return response?.data?.data?.pricing;
  } catch (error: any) {
    console.error("FAQ Page Data Error:", error?.response || error?.message);
    return null;
  }
};
